import {useContext, useMemo} from "react";
import {Context} from "./context";

const useUAlert = propsContext => {
    const alertContext = useContext(propsContext || Context)
    return useMemo(() => {
        return alertContext
    }, [alertContext])
}
export default useUAlert